<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="400px"
    class="member-limit-dialog-box "
    :mask-closable="false"
    :footer="null"
    @cancel="TipDialogVisible=false"
  >
    <div
      class="dialog-tip-box"
    >
      <i class="icon iconfont iconicon-test68" />
      <h2>{{ $t('message["1637"]') }}</h2>
      <div class="d-tip-con">
        <slot name="tip-slot" />
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          @click="leavelHandler(false)"
        >
          {{ confirmText }}
        </a-button>
        <a-button
          @click="leavelHandler(true)"
        >
          {{ cancelText }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
import i18n from '@/lib/language'
export default {
  props: {
    confirmText: {
      type: String,
      default: i18n.t('message["616"]')
    },
    cancelText: {
      type: String,
      default: i18n.t('message["589"]')
    }
  },
  data () {
    return {
      TipDialogVisible: false
    }
  },
  computed: {
    cId () {
      return this.orgItemData.cid
    }
  },
  methods: {
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    leavelHandler (b) {
      this.$emit('leavelHandler', b)
    }
  }
}
</script>
